import { FaChevronLeft, FaChevronRight, FaSearchPlus } from 'react-icons/fa';
import { IoLogoAndroid } from 'react-icons/io';
import { FaChevronDown } from 'react-icons/fa';
import { FaChevronUp } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import { FaRegPlusSquare } from 'react-icons/fa';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { FaTimes } from 'react-icons/fa';
import { FaTv } from 'react-icons/fa';
import { RxCross2 } from 'react-icons/rx';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { BiLoaderCircle } from 'react-icons/bi';
import { FaSignInAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { VscTriangleDown } from 'react-icons/vsc';
import { FiArrowRight, FiCalendar } from 'react-icons/fi';
import { FiArrowLeft } from 'react-icons/fi';
import { FaPlay } from 'react-icons/fa';
import { HiOutlineChartBar } from 'react-icons/hi';
import { GoPlusCircle } from 'react-icons/go';
import { FaRegClock } from 'react-icons/fa';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { FaRegFileLines } from 'react-icons/fa6';
import { PiLadderSimpleLight } from 'react-icons/pi';
import { LuFileCheck } from 'react-icons/lu';
import { FaCoins } from 'react-icons/fa';
import { FaScroll } from 'react-icons/fa';
import { FaMoneyBill } from 'react-icons/fa6';
import { FaGift } from 'react-icons/fa';
import { FaBaseballBall } from 'react-icons/fa';
import { FaDice } from 'react-icons/fa';
import { FaEquals } from 'react-icons/fa';
import { FaHandHoldingUsd } from 'react-icons/fa';
import { BsBank } from 'react-icons/bs';
import { FaFilter } from 'react-icons/fa';
import { FiHeart } from 'react-icons/fi';
import { IoWallet } from 'react-icons/io5';
import { CiPlay1 } from 'react-icons/ci';
import { FaRegUser } from 'react-icons/fa6';
import { MdSportsCricket } from 'react-icons/md';
import { MdCampaign } from 'react-icons/md';
import { FaSearch } from 'react-icons/fa';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { IoHeartSharp } from 'react-icons/io5';
import { MdFullscreen } from 'react-icons/md';
import { MdFullscreenExit } from 'react-icons/md';
import { CgPlayButtonR } from 'react-icons/cg';
import { FaWhatsapp } from 'react-icons/fa';
import { FaSpinner } from 'react-icons/fa';
import { BsFan } from 'react-icons/bs';



export const Icons = {
  Android: IoLogoAndroid,
  SearchPlus: FaSearchPlus,
  Down: FaChevronDown,
  Up: FaChevronUp,
  Menu: FaBars,
  PlusSquare: FaRegPlusSquare,
  MinusSquare: AiOutlineMinusSquare,
  Close: FaTimes,
  Tv: FaTv,
  Cross: RxCross2,
  Eye: FaEye,
  EyeSlash: FaEyeSlash,
  Home: FaHome,
  Loading: BiLoaderCircle,
  SignIn: FaSignInAlt,
  Lock: FaLock,
  TriangleDown: VscTriangleDown,
  Calendar: FiCalendar,
  Back: FaChevronLeft,
  Forward: FaChevronRight,
  ArrowLeft: FiArrowLeft,
  ArrowRight: FiArrowRight,
  Play: FaPlay,
  ChartBar: HiOutlineChartBar,
  PlusCircle: GoPlusCircle,
  Clock: FaRegClock,
  Info: IoMdInformationCircleOutline,
  File: FaRegFileLines,
  Ladder: PiLadderSimpleLight,
  FileCheck: LuFileCheck,
  Coins: FaCoins,
  Scroll: FaScroll,
  MoneyBill: FaMoneyBill,
  Gift: FaGift,
  Baseball: FaBaseballBall,
  Dice: FaDice,
  Equals: FaEquals,
  HandHoldingUsd: FaHandHoldingUsd,
  Bank: BsBank,
  Filter: FaFilter,
  Heart: FiHeart,
  Wallet: IoWallet,
  Inplay: CiPlay1,
  User: FaRegUser,
  Cricket: MdSportsCricket,
  Announcement: MdCampaign,
  Search: FaSearch,
  Check: FaRegCircleCheck,
  HeartSharp: IoHeartSharp,
  Maximize: MdFullscreen,
  Minimize: MdFullscreenExit,
  PlayTv: CgPlayButtonR,
  Whatsapp: FaWhatsapp,
  Spinner: FaSpinner,
  Fan: BsFan,
};
